import { AttachmentType } from '@fiverr-private/inspire_listings/src/types/inspire';
import { mixpanel } from '@fiverr-private/obs';

const track = (eventName: string, properties: object = {}) => {
    mixpanel.track(`Inspire Delivery Page - ${eventName}`, properties);
};

export enum Platform {
    Mobile = 'Mobile',
    Desktop = 'Desktop',
}

export enum TrackAction {
    Save = 'Save',
    Unsave = 'Unsave',
    ViewGig = 'View Gig',
    ViewSeller = 'View Seller',
    ContactSeller = 'Contact Seller',
    Play = 'Play',
    Pause = 'Pause',
    SoundOn = 'Sound On',
    SoundOff = 'Sound Off',
}

export interface TrackActionProps {
    deliveryId: string;
    gigId: string;
    sellerId: string;
    itemType: AttachmentType;
    subCategoryId: number;
    action: TrackAction;
    platform: Platform;
}

interface TrackActionMixpanelProps {
    'Delivery Id': string;
    'Gig Id': string;
    'Seller Id': string;
    'Item type': AttachmentType;
    'Subcategory Id': number;
    Action: TrackAction;
    Platform: Platform;
}

export const trackAction = (properties: TrackActionProps) => {
    track('Action', {
        'Delivery Id': properties.deliveryId,
        'Gig Id': properties.gigId,
        'Seller Id': properties.sellerId,
        'Item type': properties.itemType,
        'Subcategory Id': properties.subCategoryId,
        Action: properties.action,
        Platform: properties.platform,
    } satisfies TrackActionMixpanelProps);
};

export const trackView = () => {
    track('View');
};
